import { useEffect, useState } from 'react'

import { Box, Button, Flex, Grid, GridProps, HStack } from '@chakra-ui/react'

import { useLocalPlayer } from '../../context/localPlayerContext'
import { useVideoCallRoom } from '../../context/videoCallRoomContext'
import { CameraButton } from '../CameraButton/CameraButton'
import { MediaNotEnabledPopover } from '../MediaNotEnabledPopover/MediaNotEnabledPopover'
import { MicButton } from '../MicButton/MicButton'
import { ScreenShareButton } from '../ScreenShareButton/ScreenShareButton'
import { VideoCallMenu } from '../VideoCallMenu/VideoCallMenu'

type Props = {
  colorScheme?: 'blue' | 'green'
  bgColor?: GridProps['bgColor']
  canShareScreen: boolean
  canLeaveRoom?: boolean
}

export const VideoCallRoomControl: React.FC<Props> = ({
  colorScheme = 'blue',
  bgColor = 'gray.900',
  canShareScreen = true,
  canLeaveRoom = true,
}) => {
  const { roomStatus, leave: leaveRoom } = useVideoCallRoom()

  const {
    localMicrophoneEnabled,
    localCameraEnabled,
    localScreenEnabled,
    stopLocalScreen,
  } = useLocalPlayer()

  const [showMediaNotEnabledPopover, setShowMediaNotEnabledPopover] =
    useState(true)

  useEffect(() => {
    if (localMicrophoneEnabled || localCameraEnabled) {
      setShowMediaNotEnabledPopover(false)
    }
  }, [localMicrophoneEnabled, localCameraEnabled])

  return (
    <Grid
      as="header"
      gridTemplateColumns="1fr auto 1fr"
      columnGap={{ base: '2', lg: '8' }}
      px="4"
      h="full"
      w="full"
      bgColor={bgColor}
      color="white"
    >
      <VideoCallMenu buttonType="normal" colorScheme={colorScheme} />

      <Flex justify="center">
        <HStack spacing={{ base: '4', lg: '12' }}>
          {canLeaveRoom && (
            <Button
              colorScheme="red"
              isDisabled={roomStatus !== 'joining'}
              h="48px"
              onClick={() => {
                leaveRoom()
                // 画面共有中に終了した場合に確実に画面共有を終了する
                if (localScreenEnabled) {
                  stopLocalScreen()
                }
              }}
            >
              通話終了
            </Button>
          )}
          <Flex>
            <HStack spacing={{ base: '1.5', lg: '3' }}>
              <MicButton colorScheme={colorScheme} />
              <MediaNotEnabledPopover
                isVisible={showMediaNotEnabledPopover && roomStatus !== 'left'}
                onClose={() => setShowMediaNotEnabledPopover(false)}
                placement="bottom"
                triggerHeight="48px"
              />
              <CameraButton colorScheme={colorScheme} />
            </HStack>
            {canShareScreen && roomStatus === 'joining' && (
              <Box ml={{ base: '3', lg: '6' }}>
                <ScreenShareButton colorScheme={colorScheme} />
              </Box>
            )}
          </Flex>
        </HStack>
      </Flex>
    </Grid>
  )
}
